export var getInternalHref = function (href, isFrodor) {
    return isFrodor ? href : 'https://artists.spotify.com'.concat(href);
};
